import { Link, useLocation } from 'react-router-dom';
import { ArrowRight, Smartphone, Gamepad2 } from 'lucide-react';

const Hero = () => {
    const location = useLocation();

    return (
        <div className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
            {/* Background gradients */}
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0">
                <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-remy-primary/20 rounded-full blur-[100px] animate-pulse"></div>
                <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-remy-secondary/20 rounded-full blur-[100px] animate-pulse delay-1000"></div>
            </div>

            <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <div className="animate-fade-in">
                    <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight mb-8">
                        <span className="block text-white mb-2">Building the future of</span>
                        <span className="bg-clip-text text-transparent bg-gradient-to-r from-remy-primary via-remy-secondary to-remy-accent">
                            mobile experiences
                        </span>
                    </h1>

                    <p className="mt-6 max-w-2xl mx-auto text-xl text-gray-300 mb-10 leading-relaxed">
                        Remy Group creates premium tools and immersive games that redefine what's possible on your device.
                    </p>

                    <div className="flex flex-col sm:flex-row justify-center gap-4 animate-slide-up">
                        <Link
                            to="/#apps"
                            onClick={(e) => {
                                if (location.pathname === '/') {
                                    e.preventDefault();
                                    const el = document.getElementById('apps');
                                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                                }
                            }}
                            className="group inline-flex items-center px-8 py-4 border border-transparent text-lg font-medium rounded-full text-white bg-remy-primary hover:bg-remy-primary/90 transition-all shadow-lg hover:shadow-remy-primary/50"
                        >
                            <Smartphone className="mr-2 h-5 w-5" />
                            Explore Apps
                            <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
                        </Link>
                        <Link
                            to="/#games"
                            onClick={(e) => {
                                if (location.pathname === '/') {
                                    e.preventDefault();
                                    const el = document.getElementById('games');
                                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                                }
                            }}
                            className="group inline-flex items-center px-8 py-4 border border-white/20 text-lg font-medium rounded-full text-white hover:bg-white/10 transition-all backdrop-blur-sm"
                        >
                            <Gamepad2 className="mr-2 h-5 w-5" />
                            Play Games
                        </Link>
                    </div>
                </div>
            </div>

            {/* Decorative elements */}
            <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce text-gray-500">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                </svg>
            </div>
        </div>
    );
};

export default Hero;
